<template>
  <div>
    <v-toolbar flat color="transparent" style="background: transparent">
      <v-toolbar-title>
        <v-btn flat style="line-height: 10px" @click="goBack">
          <span class="fas fa-chevron-left mr-2"></span>
          {{ $t('Back') }}
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <lang-dropdown></lang-dropdown>
    </v-toolbar>
    <div class="container" style="padding: 25px 0">
      <template v-if="pagelist.length == 0">
        <div class="container text-xs-center">
          <div class="row">
            <div class="col s12 m6 offset-m3">
              <img src="/static/img/assets/get_started/no_page.png" alt class="responsive-img" />
              <h3 class="headline">{{ $t('You dont have any Facebook page or') }}</h3>
              <h1>{{ $t('No permission to access Facebook page') }}</h1>

              <a
                href="https://www.facebook.com/pages/creation/"
                target="_blank"
                class="btn"
                style="width: 100%; margin-bottom: 15px"
                >{{ $t('If you dont have any Facebook page, Create new page') }}</a
              >
              <p>{{ $t('or') }}</p>
              <a href="javascript:void(0);" class="btn" style="width: 100%" @click="logout">{{
                $t('If you have page, Login again and Allow Facebook page permission')
              }}</a>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <transition name="fade" mode="out-in">
            <div v-if="stage == 'select-page'"></div>
            <div v-else-if="stage == 'confirm-install'"></div>
          </transition>
        </div>

        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          mode="out-in"
        >
          <div v-if="stage != 'confirm-install'">
            <div class="text-xs-center">
              <h3 class="headline" style="margin-bottom: 25px">
                {{ $t('Select your Facebook Page to install Zwiz.ai chatbot') }}
              </h3>

              <p style="margin_top: 45px; margin-bottom: 25px">
                {{ $t("Only Admin page can install Chatbot. The page doesn't show up") }}
                <a
                  href="https://blog.zwiz.ai/%E0%B8%96%E0%B9%89%E0%B8%B2%E0%B9%80%E0%B8%9E%E0%B8%88%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ $t('click') }}</a
                >
              </p>
            </div>

            <div class="pages">
              <div v-for="(page, index) in computedPage" :key="'page_' + page.id">
                <page-item v-model="computedPage[index]" class="page">
                  <div
                    v-if="stage == 'select-page'"
                    slot="select-page"
                    style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
                    @click="onConfirmSubscribe(page)"
                  ></div>
                </page-item>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-xs-center">
              <h3 class="headline" style="margin-bottom: 25px">
                {{ $t('chatbot will be installed to') }}
              </h3>
            </div>
            <v-card style="max-width: 300px; margin: auto; border-radius: 20px">
              <v-card-text class="text-xs-center pt-5">
                <div>
                  <v-avatar
                    :size="150"
                    color="grey lighten-4"
                    style="margin: auto; border: 1px solid #eee"
                    class="elevation-2"
                  >
                    <img
                      class="circle"
                      :src="
                        'https://graph.facebook.com/' +
                        currentPage.id +
                        '/picture?width=100&height=100&SameSite=None'
                      "
                      alt
                    />
                  </v-avatar>
                  <p class="headline primary--text mt-4 mb-5 text-truncate">
                    {{ currentPage.name }}
                  </p>
                  <span class="page-role">
                    <template v-if="!currentPage.isAdmin">{{ $t('No permission') }}</template>
                    <template v-else>{{ pagerole }}</template>
                  </span>
                  <v-btn
                    large
                    color="primary"
                    depressed
                    class="ma-0"
                    style="width: 100%; margin-top: 25px; border-radius: 50px"
                    @click="onSubscribeBot"
                    >{{ $t('install bot') }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </div>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import Velocity from 'velocity-animate'
import { mapGetters } from 'vuex'
import PageItem from '@/components/view/allbots/PageItem'
import LangDropdown from '@/components/elements/LangDropdown'
export default {
  components: {
    PageItem,
    LangDropdown
  },
  data: function () {
    return {
      currentView: 'select-page',
      stage: 'select-page',
      currentPageIndex: null,
      currentPage: null,
      themelist: [],
      selectedTheme: undefined
    }
  },

  computed: {
    ...mapGetters({
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      pagelist: 'unsubscribedPage',
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    pagerole: function () {
      const vm = this
      let page = vm.currentPage
      if (!vm.currentPage) {
        return ''
      } else {
        if (page.perms) {
          const role = page.perms.find((val) => val == 'ADMINISTER')
          if (role) {
            return vm.$t('Administer')
          } else return ''
        } else if (page.tasks) {
          const role = page.tasks.find((val) => val == 'MANAGE')
          if (role) {
            return vm.$t('Administer')
          } else return ''
        } else {
          return ''
        }
      }
    },
    computedPage: function () {
      const vm = this
      let pagelist = []
      try {
        pagelist =
          this.pagelist && this.pagelist.length > 0
            ? this.pagelist.slice(0).sort(function (a, b) {
                if (a.tasks && b.tasks) {
                  if (a.tasks.indexOf('MANAGE') > -1 && b.tasks.indexOf('MANAGE') == -1) {
                    return -1
                  } else if (a.tasks.indexOf('MANAGE') == -1 && b.tasks.indexOf('MANAGE') > -1) {
                    return 1
                  }
                } else if (a.perms && b.perms) {
                  if (a.perms.indexOf('ADMINISTER') > -1 && b.perms.indexOf('ADMINISTER') == -1) {
                    return -1
                  } else if (
                    a.perms.indexOf('ADMINISTER') == -1 &&
                    b.perms.indexOf('ADMINISTER') > -1
                  ) {
                    return 1
                  }
                }
                return 0
              })
            : []
      } catch (error) {
        console.error(error)
      }
      if (vm.currentPageIndex == null) {
        return pagelist
      }

      return pagelist.filter(function (item) {
        if (item.id == vm.currentPageIndex) {
          vm.currentPage = item
        }
        return item.id == vm.currentPageIndex
      })
    },
    welcomeCustomerSays: {
      get() {
        try {
          let vm = this
          if (vm.welcome && vm.welcome.customerSay && vm.welcome.customerSay != '') {
            var customerSays =
              vm.welcome && vm.welcome.customerSay ? vm.welcome.customerSay.split(',') : []
            var result = []
            result = customerSays.map((val) => ({ text: val }))
            return result
          } else {
            return []
          }
        } catch (error) {
          console.error(error)
          return []
        }
      },
      set(value) {
        try {
          let vm = this
          var result = value.map((val) => val.text)
          vm.welcome.customerSay = result.join(',')
        } catch (error) {
          console.error(error)
        }
      }
    },
    welcomeChoices: {
      get() {
        try {
          let vm = this
          if (vm.welcome && vm.welcome.choice && vm.welcome.choice != '') {
            var choices = []
            choices = vm.welcome.choice.split(',')
            var result = choices.map((val) => ({ text: val }))
            return result
          } else {
            return []
          }
        } catch (error) {
          console.error(error)
          return []
        }
      },
      set(value) {
        try {
          let vm = this
          var result = value.map((val) => val.text)
          vm.welcome.choice = result.join(',')
        } catch (error) {
          console.error(error)
        }
      }
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal == null) {
        this.currentPage = null
      }
    }
  },
  mounted: function () {
    let vm = this
    vm.getAllPublicTheme(function () {
      vm.selectedTheme = vm.themelist[0]
    })
  },
  methods: {
    onConfirmSubscribe(page) {
      this.stage = 'confirm-install'
      this.currentPageIndex = page.id
      this.currentPage = page
    },
    logout: function () {
      var vm = this
      var isFacebook = vm.isFacebook
      vm.$store.dispatch('logout', null).then()
      if (isFacebook) {
        localStorage.setItem('allowed_business_management', true)
        vm.$router.push('/' + vm.currentLang + '/login')
      } else {
        vm.$router.push('/' + vm.currentLang + '/nigol')
      }
    },
    onSubscribeBot: function () {
      if (this.currentPageIndex == null || this.selectedTheme == null) {
        return
      }
      let vm = this
      let page = this.currentPage
      let data = {
        pageid: page.id,
        page_access_token: page.access_token,
        theme: this.selectedTheme.themeid,
        pagename: page.name,
        ownerid: this.$store.state.userid,
        facebook_name: this.$store.state.facebook_name,
        status: false
      }

      vm.$store.dispatch('loading')
      // vm.$store.dispatch('addModalWelcome')
      api.newSubscribe(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        vm.$store.dispatch('updateNewBotlist').then(
          function () {
            var bot = vm.botlist.find((val) => val.pageid == page.id)

            if (bot) {
              vm.$store.dispatch('selectBot', bot)
              vm.$store.dispatch('loading')
              var supportcode = vm.$route.query.supportcode
                ? '?supportcode=' + vm.$route.query.supportcode
                : ''
              vm.$router.push('/' + vm.currentLang + '/setup' + supportcode)

              var getstarteddata = {
                access_token: bot.page_access_token,
                pageid: bot.pageid,
                status: false,
                getstarted_menu: {
                  get_started: {
                    payload: 'menu'
                  }
                }
              }
              vm.savegetstartedmenu(getstarteddata).then(() => {})
            } else {
              vm.$emit('close')
              vm.$store.dispatch('loading')
            }
          },
          function (error) {
            console.error(error)
            vm.$emit('close')
            vm.$store.dispatch('loading')
            vm.errorMessage = 'Can not update chatbot'
          }
        )
      })
    },
    savegetstartedmenu(data) {
      return new Promise((resolve, reject) => {
        api.savegetstartedmenu(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    getAllPublicTheme: function (callback) {
      let vm = this
      vm.themelist = [
        {
          themeid: 'ecommercebasic',
          themename: 'ecommercebasic',
          description: '',
          themepic: '',
          ispublic: true
        }
      ]
      callback()
    },
    goBack: function () {
      var vm = this
      if (vm.currentView == 'select-page') {
        if (vm.stage == 'select-page') {
          vm.$emit('close')
        } else if (vm.stage == 'confirm-install') {
          vm.currentPageIndex = null
          vm.stage = 'select-page'
        }
      }
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/getstarted/GetStarted.vue